// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f339d496","488":"66a16b2f"}[chunkId] + ".chunk.js";
};